import React, {useState} from "react";

import './Team.detail.scss';
import SpinnerLoader from "../../visuals/SpinnerLoader";
import {useQuery} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import {useNavigate, useParams} from "react-router-dom";
import TeamRenameDialog from "../dialogs/Team.rename.dialog";
import TeamDeleteDialog from "../dialogs/Team.delete.dialog";
import {clearGqlTypename} from "../../utils/clearTypename";
import {useTranslation} from "react-i18next";
import {PageViewLog} from "../../services/interactions/page.view";
import AuditTrail from "../../services/interactions/audit.trail";

function TeamDetail({ event, currentUser, match }) {
    let { teamId } = useParams();
    const {t} = useTranslation(['common','teams']);
    const [team, setTeam] = useState(null);
    const navigate = useNavigate();

    const [openTeamRenameModal, setOpenTeamRenameModal] = useState(false);
    const [openTeamDeleteModal, setOpenTeamDeleteModal] = useState(false);

    useQuery(gqlSchemaLibrary.teams.queries.getTeam, {
        variables: {
            teamId: teamId
        },
        onCompleted: ({ getTeam }) => {
            setTeam(clearGqlTypename(getTeam));
        },
        fetchPolicy: 'cache-and-network'
    })

    if (!team) {
        return <SpinnerLoader/>
    }

    const onClickTeamManage = () => {
        navigate(`/teams/manage/${team._id}`);
    }

    const onClickRenameTeam = () => {
        setOpenTeamRenameModal(true);
    }

    const onBack = () => {
        AuditTrail.sendLog(event, {tag: 'button', event: 'onClick', action: 'button back'});
        navigate(-1);
    }

    const closeRenameModal = (name) => {
        if (name) {
            team.name = name;
            setTeam(team);
        }
        setOpenTeamRenameModal(false);
    }

    const onClickDeleteTeam = () => {
        setOpenTeamDeleteModal(true);
    }

    const closeDeleteModal = (team) => {
        setOpenTeamDeleteModal(false);
    }

    const onClickEditTeam = () => {
        if (currentUser.userRoles.userClinicians.create) {
            navigate(`/teams/edit/${team._id}`);
        }
    }

    return (
        <div id="TeamDetail">
            <div className="filter">
            </div>
            <div className="teamContent">
                <div className="sideA">
                    <p className="title">{team.name}</p>
                    {
                        currentUser.userRoles.userClinicians.create?
                            <div className="containerButtons">
                                <button className="primary gray" onClick={onClickRenameTeam}>
                                    {t('rename')}<br/> {t('teams:team')}
                                </button>
                                <button className="primary gray" onClick={onClickDeleteTeam}>
                                    {t('remove')}<br/> {t('teams:team')}
                                </button>
                            </div> : ''
                    }
                </div>
                <div className="sideB">
                    <div className="title">
                        <span className="_link" onClick={onClickEditTeam}>{t('teams:team-information')}</span>
                    </div>
                    <h3 className="subtitle">{t('description')}</h3>
                    <p className="text">{team.description}</p>
                    <div className="divider"></div>
                    <div className="title">
                        <span className="_link" onClick={onClickTeamManage}>{t('teams:members')}</span>
                    </div>
                    <p className="text">{team.users.length+team.teams.length} {t('teams:members').toLowerCase()}</p>
                    <div className="divider"></div>
                    <p className="title">{t('teams:programs')}</p>
                    {
                        team.programs.length === 0?
                            (<p className="text">{team.name + ' is not in any program'}</p>) : ''
                    }
                    {
                       team.programs.map((p, index) => (
                            <p key={index} className="text">{p.name}</p>
                        ))
                    }
                    <div className="containerButtons">
                        {
                            currentUser.userRoles.userPatients.edit?
                                <button className="primary gray" onClick={onBack}>
                                    {t('back')}
                                </button> : ''
                        }
                    </div>
                </div>
            </div>
            <TeamRenameDialog event={event} team={team} openModal={openTeamRenameModal} closeModal={closeRenameModal} />
            <TeamDeleteDialog event={event} team={team} teams={[]} redirect={true} openModal={openTeamDeleteModal} closeModal={closeDeleteModal} />
        </div>
    );
}

export default PageViewLog(TeamDetail);
